import { Channel, Topic } from "../../constants";
import { PageContextUtils, MessageBrokerUtils } from "../../utils";
import React, { useCallback } from "react";

import { EmptyComponent } from "../common/EmptyComponent";
import Loadable from "react-loadable";
import { UserContextSelectors } from "../../redux/selectors";
import { useSelector } from "react-redux";
import { useFeature } from "../../hooks/useFeature";
import { AppFeatures } from "../../constants/featureFlags";

const MiniCashierOnDemand = Loadable({
  loader: () =>
    import(/* webpackChunkName: "container/minicashier" */ "./MiniCashier"),
  loading: EmptyComponent
});

const { miniCashierUrl } = PageContextUtils.getUrlResourceData();

export const MiniCashier = props => {
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const isInMiniCashierFeature = useFeature(AppFeatures.MINI_CASHIER);

  const isMiniCashierEnabled = isInMiniCashierFeature && miniCashierUrl;

  if (!isAuthenticated || !isMiniCashierEnabled) return null;

  return <MiniCashierOnDemand {...props} />;
};

export const useMiniCashierCommunicationHandler = () => {
  const openCashier = useCallback(data => {
    MessageBrokerUtils.publish({
      channel: Channel.PAYMENT,
      topic: Topic.CTA_Cashier_Open,
      headers: {
        publisher: "UAA"
      },
      data: data
    });
  }, []);

  return { openCashier };
};
